import { createBrowserRouter } from 'react-router';

/**
 * Components
 */
import PageAuthLogin from '@/pages/auth/login';
import PageAuthPrivy from '@/pages/auth/privy';
import Page404 from '@/pages/errors/404';

export const router = createBrowserRouter([
    {
        path: '/auth/login',
        element: <PageAuthLogin />,
    },
    {
        path: '/auth/privy',
        element: <PageAuthPrivy />,
    },
    {
        path: '*',
        element: <Page404 />,
    },
]);
